import { GlLink, GlButton } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'InfoBanner',
    components: {
        GlLink,
        GlButton
    },
    inject: [
        'serviceDeskCalloutSvgPath',
        'serviceDeskEmailAddress',
        'canAdminIssue',
        'canAdminProject',
        'serviceDeskSettingsPath',
        'isServiceDeskEnabled',
        'serviceDeskHelpPath'
    ],
    computed: {
        canSeeEmailAddress () {
            return this.canAdminIssue && this.isServiceDeskEnabled;
        },
        canEnableServiceDesk () {
            return this.canAdminProject && !this.isServiceDeskEnabled;
        }
    }
};
